import React, { useContext, useEffect, useState } from "react";
import "./Assets.css";
import {
  DeleteTwoTone,
  EditOutlined,
  PlusOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import {
  Row,
  Button,
  Input,
  Table,
  Tooltip,
  Col,
  Card,
  Select,
  Space,
  Skeleton,
  TableColumnsType,
  Drawer,
} from "antd";
import AssetModel, { PmtMethod } from "./AssetModel";
import { ColumnsType } from "antd/es/table";
import FixedAssetsService, {
  Asset_Type,
  AssetPurchase_Type,
  AssetStatus,
} from "../../Services/FixedAssetsServiceNew";
import { useClient } from "../../Context/ClientContext";
import { useTheme } from "../../Context/ThemeContext";
import search from "../../Images/search.svg";
import { Utils } from "../../../Utilities/Utils";
import ViewAssetModel from "./ViewAssetModel";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/PageRoute";
import AssetJournalModal from "./AssetJournalModal";
import { useKeyboardShortcuts } from "../../Common/KeyboardShortcuts ";
import { useLocation, useNavigate } from "react-router-dom";
import { dayjs } from "../../../Utilities/dayjs";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";

interface IDataType {
  key: string;
  id: string;
  sno: number;
  number: {
    no: string;
    id: string;
  };
  name: string;
  date: string;
  price: string;
  isDepreciable: string;
  status: AssetStatus;
  invoiceDetail: any;
  // journals: any[];
  // jrNumber: any[];
}
// interface ExpandedDataType {
//   key: React.Key;
//   date: string;
//   gst: any;
//   invNumber: string;
//   partiallyPaidAmount: number;
//   price: number;
//   purPartyLedger: string;
//   purPayDate: string;
//   purPayMethod: PmtMethod;
//   purPayRef: string;
//   purPaymentLedger: string;
//   qty: number;
//   taxCredit: boolean;
//   voucherDate: string;
//   childAssetDetail: ChildAssetDetail[];
// }

// interface ChildAssetDetail {
//   accumulatedDepreciation: number;
//   childAssetName: string;
//   childAassetNumber: string;
//   depAmount: number;
//   depreciationLastDate: string;
//   depreciationStartDate: string;
//   description: string;
//   disposalDate: string;
//   disposalPartyLedger: string;
//   disposalPaymentLedger: string;
//   disposalPaymentRef: string;
//   disposalValue: number;
//   identityCode: string;
//   isDisposed: boolean;
//   lifeCycleDuration: number;
//   location: string;
//   model: string;
//   residualValue: number;
//   warrantyExpDate: string;
//   wdValue: number;
//   wdvDate: string;
//   writeOffValue: number;
// }

const FixedAssets = ({
  setFixedAssetListPassToOpeningBalance,
  setOpenAssetModal,
  assetPurchaseType,
}: any) => {
  const location = useLocation();
  const { clientSpecificRole } = useUser();
  const { openNotification } = useContext(notificationContext);
  const navigate = useNavigate();
  const { themeData } = useTheme();
  const { currentClient, companySettings } = useClient();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
  const [successRollBack, setSeccesRollBack] = React.useState<boolean>(false);
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState<number>(15);
  const [fixedAssetList, setFixedAssetList] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [editAsset, setEditAsset] = React.useState<any>(false);
  const [searchAsset, setSearchAsset] = React.useState("");
  const [isViewModelOpen, setIsViewModelOpen] = useState<boolean>(false);
  const [assetId, setAssetId] = React.useState<{
    assetId: string;
    childAssetName: string;
  }>({
    assetId: "",
    childAssetName: "",
  });
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  const [type, setType] = React?.useState<boolean>(Boolean);
  const [filterDate, setFilterDate] = React.useState<any>(
    JSON.parse(localStorage.getItem("LockPeriod")!)
      ? {
          from: JSON.parse(localStorage.getItem("LockPeriod")!).from,
          to: JSON.parse(localStorage.getItem("LockPeriod")!).to,
        }
      : {
          from: dayjs(companySettings?.period?.from).format("DD/MM/YYYY"),
          to: dayjs(companySettings?.period?.to).format("DD/MM/YYYY"),
        }
  );

  const [changeStatus, setChangeStatus] = React.useState<number>(
    AssetStatus.Active
  );
  const [purchaseType, setPurchaseType] = React.useState<AssetPurchase_Type>(
    assetPurchaseType === undefined ? AssetPurchase_Type.All : assetPurchaseType
  );
  const [deleteOrRevive, setDeleteOrRevive] = React.useState<any>({
    id: "",
    isRev: null,
  });
  const [journalModel, setJournalModel] = React.useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: {} });
  const [refreshAtDelete, setRefreshAtDelete] = React.useState<boolean>(false);

  // const showModal = () => {
  //   setEditAsset({ id: null });
  //   setIsModalOpen(true);
  // };

  // const modelCancel = () => {
  //   setIsModalOpen(false);
  //   setIsConfirmation(false);
  //   // form.resetFields();
  // };

  const getList = async (
    clientId: string,
    from: string = "",
    to: string = "",
    start: number,
    length: number,
    sortCol: any,
    sortDir: any,
    search: string,
    type: Asset_Type,
    status: AssetStatus,
    purchaseType: AssetPurchase_Type
  ) => {
    await FixedAssetsService.getChildAssetList(
      clientId,
      from,
      to,
      start,
      length,
      sortCol,
      sortDir,
      search,
      type,
      status,
      purchaseType
    )
      .then((res) => {
        if (res != null || res?.items?.length > 0) {
          setFixedAssetList(
            res?.items?.map((e: any, index: number) => {
              return {
                key: index,
                sno: index + 1,
                id: e?.id,
                assetLedger: e?.assetLedger,
                // number: { no: e?.number, id: e?.id },
                number: e?.assetNumber,
                name: e?.assetName,
                date: e?.invoiceDate,
                status: e?.assetStatus,
                price: e?.invoiceTotalValue,
                invoiceDetail: e?.invoiceDetail,
                isDepreciable: e?.isDepreciable === true ? "Yes" : "No",
              };
            })
          );
          setTotalRecords(res?.totalRecords);

          setFixedAssetListPassToOpeningBalance(res?.items);

          console.log(" abc ", res?.items);
        } else if (res.items.length === 0) {
          setFixedAssetList([]);
          setTotalRecords(res?.totalRecords);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
    setLoading(false);
  };

  console.log("fixedAssetList: ", fixedAssetList);

  //for getlist
  useEffect(() => {
    setLoading(true);

    getList(
      currentClient?.id!,
      dayjs(filterDate?.from, "DD/MM/YYYY").toISOString(),
      dayjs(filterDate?.to, "DD/MM/YYYY").endOf("day").toISOString(),
      (page - 1) * pageSize,
      pageSize,
      undefined,
      undefined,
      searchAsset,
      Asset_Type?.All,
      changeStatus,
      purchaseType
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    trigger,
    page,
    pageSize,
    searchAsset,
    changeStatus,
    refreshAtDelete,
    successRollBack,
    purchaseType,
  ]);

  // // ----- Short-Cut for Open Model -----F
  // useKeyboardShortcuts("N", ["shiftKey"], () => {
  //   setIsModalOpen(true);
  // });

  const [openEditModal, setOpenEditModal] = useState(false);

  const permissionEdit = findUserPremission(
    ["Voucher.Asset.FixedAsset.Edit"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Edit,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  const permissionDelete = findUserPremission(
    ["Voucher.Asset.FixedAsset.Delete"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Delete,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  const columns: ColumnsType<IDataType> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Asset Reference",
      dataIndex: "number",
      key: "number",
      render: (_, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <span
            style={{ cursor: "pointer", color: "#1677FF" }}
            onClick={() => {
              setIsViewModelOpen(true);
              setAssetId({
                assetId: record?.id,
                childAssetName: record?.name,
              });
              setType(false);
            }}
          >
            {record?.number}
          </span>
        </Skeleton>
      ),
    },
    {
      title: "Asset Name",
      dataIndex: "name",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.name}
        </Skeleton>
      ),
    },
    {
      title: "Purchase Date",
      dataIndex: "date",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {dayjs(record?.date).format("DD/MM/YYYY")}
        </Skeleton>
      ),
    },
    {
      title: "Total Value",
      dataIndex: "price",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "right" },
          }}
          title={false}
        >
          {Utils.getFormattedNumber(record?.price)}
        </Skeleton>
      ),
    },
    {
      title: "Depreciable Asset",
      dataIndex: "isDepreciable",
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          {record?.isDepreciable}
        </Skeleton>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          <>
            {permissionEdit ? (
              record.status !== AssetStatus.Disposed ? (
                <Tooltip title="Edit" color="#444653" placement="top">
                  {location.pathname ==
                  `/billing/clients/${currentClient?.id}/settings/openingBalance` ? (
                    <>
                      <EditOutlined
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setOpenEditModal(true);
                          navigate(
                            `/billing/clients/${currentClient?.id}/settings/openingBalance`,
                            {
                              state: {
                                data: record,
                              },
                            }
                          );
                        }}
                        // onClick={showDrawerEditModal}
                      ></EditOutlined>
                      <Drawer
                        closable={false}
                        width="900"
                        className="openingBalanceAssetDrawer"
                        onClose={() => setOpenEditModal(false)}
                        open={openEditModal}
                      >
                        <AssetModel setOpenAssetModal={setOpenEditModal} />
                      </Drawer>
                    </>
                  ) : (
                    <EditOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setIsModalOpen(true);
                        navigate(
                          `/billing/clients/${currentClient?.id}/asset/addFixedAsset`,
                          {
                            state: {
                              data: record,
                            },
                          }
                        );
                      }}
                    />
                  )}
                </Tooltip>
              ) : (
                ""
              )
            ) : (
              <></>
            )}
          </>
        </Skeleton>
      ),
    },
  ];

  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          // width: "97%",
          // marginLeft: "16px",
          marginTop:
            location.pathname ==
            `/billing/clients/${currentClient?.id}/asset/fixedAsset`
              ? 35
              : 5,
          // padding: "48px 0px 0px 0px",
          boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      >
        {location.pathname ==
          `/billing/clients/${currentClient?.id}/asset/fixedAsset` && (
          <Row
            justify={"space-between"}
            style={{
              // paddingTop: props?.partyId ? "10px" : "0px"
              // marginTop: 10,
              padding: "0px 0px 3px 0px",
            }}
          >
            {findUserPremission(
              ["Voucher.Asset.FixedAsset.Add"],
              clientSpecificRole(),
              currentClient?.id!,
              [SettingsSections.Asset],
              {
                actionType: IPermissionActionType.Add,
                dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
              }
            ) && (
              <Col>
                <Row>
                  <Col>
                    <Button
                      type="primary"
                      onClick={() =>
                        navigate(
                          `/billing/clients/${currentClient?.id}/asset/addFixedAsset`
                        )
                      }
                    >
                      <PlusOutlined />
                      Fixed Assets
                    </Button>
                  </Col>
                </Row>
              </Col>
            )}

            <Col>
              <Row>
                <Col>
                  <Input
                    style={{ width: "200px" }}
                    placeholder="Search asset"
                    allowClear
                    onChange={(e: any) => {
                      setPage(1);
                      setSearchAsset(e.target.value);
                      //console.log(e.target.value, "search");
                    }}
                    suffix={
                      loading || searchAsset ? (
                        ""
                      ) : (
                        <img alt="search" src={search} />
                      )
                    }
                  />
                </Col>
                <Space size={5}>
                  <span style={{ marginLeft: "10px" }}>Filter</span>
                  <Col style={{ justifyContent: "end", gap: 10 }}>
                    <Select
                      defaultValue={AssetStatus.Active}
                      style={{ width: 120 }}
                      options={[
                        { value: AssetStatus.All, label: "All", title: "" },
                        {
                          value: AssetStatus.Active,
                          label: "Active",
                          title: "",
                        },
                        {
                          value: AssetStatus.Disposed,
                          label: "Disposed",
                          title: "",
                        },
                      ]}
                      onChange={(e: any) => {
                        setChangeStatus(e);
                        console.log(e, "changestatusassets");
                      }}
                    />{" "}
                    <Select
                      defaultValue={AssetPurchase_Type.All}
                      style={{ width: 180 }}
                      options={[
                        {
                          value: AssetPurchase_Type.All,
                          label: "New / Old Purchase",
                          title: "",
                        },
                        {
                          value: AssetPurchase_Type.NewPurchase,
                          label: "New Purchase",
                          title: "",
                        },
                        {
                          value: AssetPurchase_Type.OldPurchase,
                          label: "Old Purchase",
                          title: "",
                        },
                      ]}
                      onChange={(e: any) => {
                        setPurchaseType(e);
                      }}
                    />
                  </Col>
                </Space>
              </Row>
            </Col>
          </Row>
        )}
        <Table
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          columns={columns}
          dataSource={
            loading
              ? (Array.from({ length: pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IDataType[])
              : fixedAssetList
          }
          // expandable={{
          //   expandedRowRender: test,
          //   // expandedRowRender: (_: any, record: any) => {
          //   //   console.log("Sel Record: ", record);
          //   //   return expandedRowRender(record?.invoiceDetail);
          //   // },
          //   defaultExpandAllRows: true,
          // }}
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
            },
            pageSizeOptions: ["10", "15", "25", "50", "100"],
          }}
          // scroll={
          //   pageSize > 15 ? { x: 1300, y: window.innerHeight - 300 } : undefined
          // }
        />
        {confirmation && (
          <ConfirmationModal
            open={confirmation}
            onNo={() => setConfirmation(false)}
            onYes={() => {
              setDeleteOrRevive({
                id: assetId,
                isRev: changeStatus === AssetStatus.Disposed ? true : false,
              });
              //console.log("yogesh");
              setConfirmation(false);
            }}
            text={
              changeStatus === AssetStatus.Disposed
                ? `Are you sure you want to revive ?`
                : `Are you sure you want to Delete this row ?`
            }
          />
        )}
        {/* {isModalOpen && (
          <AssetModel
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            isConfirmation={isConfirmation}
            setIsConfirmation={setIsConfirmation}
            modelCancel={modelCancel}
            setTrigger={setTrigger}
            editAsset={editAsset}
          />
        )} */}
        {isViewModelOpen && (
          <ViewAssetModel
            isViewModelOpen={isViewModelOpen}
            onCancel={() => setIsViewModelOpen(false)}
            assetId={assetId}
            type={type}
          />
        )}
      </Card>
      {journalModel.open && (
        <AssetJournalModal
          modal={journalModel}
          setSuccess={setSeccesRollBack}
          success={successRollBack}
          setModal={setJournalModel}
        />
      )}
    </>
  );
};
export default FixedAssets;
